import { Dispatch, SetStateAction, useEffect, useState } from "react";
import Modal from "../../components/Modal/Modal";
import { Button, Grid } from "@mui/material";
import { api } from "../../services/api";
import SelectSimple from "../../components/Selects/SelectSimple";
import InputLabel from "../../components/Inputs/InputLabel";
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import { AlertInfo } from "../../components/Alerts/Alert";
import { ProcessoType } from "../../types/ProcessoType";

type ReciboProps = {
    open: boolean
    setOpen: Dispatch<SetStateAction<boolean>>
    activeProcess: null | ProcessoType
};

export default function Recibo({ open, setOpen, activeProcess }: ReciboProps) {
    const [load, setLoad] = useState(false);
    const [options, setOptions] = useState([]);
    const [valor_recibo, setValorRecibo] = useState(``);
    const [referencia_recibo, setReferenciaRecibo] = useState<string | number>('');

    function generateRecibo() {
        if (activeProcess) {
            setLoad(true);
            api.post(`/documentrequerid/recibo_processo/${activeProcess.id_processo}`, {valor_recibo, referencia_recibo}, { responseType: 'blob' }).then(response => {
                if (response.status === 204) {
                    return AlertInfo({ icon: 'error', title: "Documento não localizado" }).then(() => setLoad(false));
                }
                const url = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = `Recibo Processo - ${activeProcess.nome_cliente}.docx`;
                link.click();
                window.URL.revokeObjectURL(url);
                setLoad(false);
                setOpen(false);
            });
        } else {
            AlertInfo({ icon: 'error', title: 'Processo não Selecionado' });
        }
    }

    async function loadData() {
        try {
            const response = await api.get(`/optionsrecibo`);
            console.log(response);
            if (response.data && response.data[0]) {
                setOptions(response.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title="Gerador de Recibo"
            maxWidth="sm"
            zIndex={2222}
        // actionClose={resetStates}
        >
            <SimpleBackdrop open={load} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <SelectSimple
                        label="Referente a"
                        value={referencia_recibo}
                        setState={setReferenciaRecibo}
                        options={options}
                        isNone
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputLabel
                        label="Valor"
                        value={valor_recibo}
                        setState={setValorRecibo}
                    />
                </Grid>
                <Grid item xs={false} sm={4}></Grid>
                <Grid item xs={12} sm={4} container alignItems="flex-end">
                    <Button
                        variant="contained"
                        fullWidth
                        color="success"
                        onClick={generateRecibo}
                    >
                        GERAR RECIBO
                    </Button>
                </Grid>
            </Grid>
        </Modal>
    );
}